'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refineLinearDomain = undefined;
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _floor2 = require('lodash/floor');
var _floor3 = _interopRequireDefault(_floor2);
var _ceil2 = require('lodash/ceil');
var _ceil3 = _interopRequireDefault(_ceil2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _linear = require('./linear');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var refineLinearDomain = exports.refineLinearDomain = function refineLinearDomain(domain) {
  var _domain = (0, _slicedToArray3.default)(domain, 2),
    min = _domain[0],
    max = _domain[1];
  var delta = max - min;
  var _factorize = (0, _linear.factorize)(delta),
    factor = _factorize.factor,
    powerScale = _factorize.powerScale;
  var scale = R.when(R.always(factor < 5), function (scale) {
    return R.divide(scale, 10);
  })(powerScale);
  if (scale >= 1) {
    return [Math.floor(min), Math.ceil(max)];
  }
  var precision = 0;
  var _scale = scale;
  while (_scale != 1) {
    precision += 1;
    _scale = _scale * 10;
  }
  return [(0, _floor3.default)(min, precision), (0, _ceil3.default)(max, precision)];
};